module.exports = "<div class=\"project-logo\">\n  <img [src]=\"project.logo\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/work/project.component.html
// module id = ./src/app/work/project.component.html
// module chunks = main